/* Floral Studio — horizontal product rails.
   Drives the hairline progress indicator under each scrollable row and
   lets the arrow keys move it. Everything else is native scrolling, so
   trackpads, touch and shift+wheel all work without help. */
(function () {
  function init(wrap) {
    var rail = wrap.querySelector('.fs-prod-grid--scroll');
    var bar = wrap.querySelector('.fs-products__progress-bar');
    if (!rail || !bar) return;

    function update() {
      var travel = rail.scrollWidth - rail.clientWidth;
      // Nothing to scroll: hide the indicator rather than show a full bar.
      wrap.classList.toggle('is-scrollable', travel > 4);
      if (travel <= 4) return;
      var visible = rail.clientWidth / rail.scrollWidth;
      var progress = rail.scrollLeft / travel;
      bar.style.width = Math.max(visible * 100, 8) + '%';
      bar.style.transform = 'translateX(' + progress * (100 / Math.max(visible, 0.08) - 100) + '%)';
    }

    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });

    rail.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var card = rail.querySelector('.fs-prod-grid__item');
      if (!card) return;
      var step = card.getBoundingClientRect().width + 24;
      rail.scrollBy({ left: e.key === 'ArrowRight' ? step : -step, behavior: 'smooth' });
      e.preventDefault();
    });

    update();
    // Images arriving late change scrollWidth
    window.setTimeout(update, 400);
    window.setTimeout(update, 1500);
  }

  function boot() {
    var wraps = document.querySelectorAll('.fs-products__rail-wrap');
    for (var i = 0; i < wraps.length; i++) init(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', boot);
})();
